<template>
  <router-view />
</template>

<script>
import $ from "jquery";

export default {
  name: "App",
};
</script>

 
